import ActionDialog from "@dashboard/components/ActionDialog";
import { ConfirmButtonTransitionState } from "@dashboard/components/ConfirmButton";
import ControlledCheckbox from "@dashboard/components/ControlledCheckbox";
import { Box } from "@saleor/macaw-ui-next";
import { FormattedMessage, useIntl } from "react-intl";

interface OrderMarkAsReceivedDialogProps {
  confirmButtonState: ConfirmButtonTransitionState;
  open: boolean;
  notifyCustomer: boolean;
  onClose: () => void;
  onConfirm: () => void;
  handleNotifyCustomer: (checked: boolean) => void;
}

const OrderMarkAsReceivedDialog = ({
  confirmButtonState,
  open,
  notifyCustomer,
  onClose,
  onConfirm,
  handleNotifyCustomer,
}: OrderMarkAsReceivedDialogProps) => {
  const intl = useIntl();

  return (
    <ActionDialog
      confirmButtonState={confirmButtonState}
      open={open}
      title={intl.formatMessage({
        id: "9Sny+Q",
        defaultMessage: "Mark order as received",
        description: "dialog header",
      })}
      onClose={onClose}
      onConfirm={onConfirm}
    >
      <Box display="grid" gap={4}>
        <FormattedMessage
          id="8WJ3ws"
          defaultMessage="This completes the order's final step. Use it when the customer has received or collected the goods."
        />
        <ControlledCheckbox
          data-test-id="notify-customer"
          name="notifyCustomer"
          label={intl.formatMessage({
            id: "qvjDj/",
            defaultMessage: "Send a delivery confirmation to the customer",
            description: "mark order as received, notify customer checkbox",
          })}
          checked={notifyCustomer}
          onChange={event => handleNotifyCustomer(event.target.value)}
        />
      </Box>
    </ActionDialog>
  );
};

OrderMarkAsReceivedDialog.displayName = "OrderMarkAsReceivedDialog";
export default OrderMarkAsReceivedDialog;
